/** Compare service/product ids from API (number, numeric string, or opaque string). */
export function entityIdsEqual(a: unknown, b: unknown): boolean {
  if (Object.is(a, b)) return true;
  if (a == null || b == null) return false;
  const na = Number(a);
  const nb = Number(b);
  if (Number.isFinite(na) && Number.isFinite(nb) && na === nb) return true;
  return String(a) === String(b);
}

export const getMyCart = (state: any) => {
  const shop: any = {};
  shop.vehicle_id = state.vehicle?.id ?? false;
  shop.appointment_slot_id = state.appointment?.id ?? false;
  shop.company_id =
    state.company_id !== undefined && state.company_id !== null
      ? state.company_id
      : false;
  shop.branch_id =
    state.branch_id !== undefined && state.branch_id !== null
      ? state.branch_id
      : false;
  const serviceLines = state.services.filter(
    (el: any) => el?.id !== undefined && el?.id !== null
  );

  shop.service_ids = serviceLines.map((el: any) => el.id);

  /**
   * Window tinting needs per-glass choices, which `service_ids` cannot carry,
   * so services also go out as objects (`{ id, qty, tint_details }`).
   */
  shop.services = serviceLines.map((el: any) => {
    const line: Record<string, unknown> = {
      id: el.id,
      qty: Number(el.qty) > 0 ? Number(el.qty) : 1,
    };
    if (Array.isArray(el.tint_details) && el.tint_details.length > 0) {
      line.tint_details = el.tint_details;
    }
    return line;
  });
  shop.products = state.products.map((el: any) => {
    return { id: el.id, qty: el.qty };
  });

  shop.cart_id = state.cart_id;

  return shop;
};
